// extracted by mini-css-extract-plugin
export default {"breadcrumbsRow":"Mq-z","breadcrumbForward":"Nq-z","breadcrumbBack":"Oq-z","selected":"Pq-z"};